import React, { useEffect, useContext } from "react";
import ReactGA from "react-ga4";
import styles from "./styles/SharingOptionsButton.scss";
import { getIconUrl } from "../../../services/asset";
import { connect } from "react-redux";
import { selectCategories } from "../../App/selectors";
import { Context as ShareContext } from "../../../ShareContex";
import history from "../../../history";
import { notification } from "../../../services";
import { HashTag } from "../../../models";
import useHrPageName from "../../../utils/useHrPageName";

function SharingOptionsButton({ disabled, category }) {
  const { toggleShare } = useContext(ShareContext);
  const hrPageName = useHrPageName(category);

  useEffect(() => {
    const adUpdated = history.location.hash === HashTag.adUpdated;
    const adNew = history.location.hash === HashTag.adNew;
    const adPromoted = history.location.hash === HashTag.adPromoted;

    if (adUpdated || adNew) {
      setTimeout(() => {
        toggleShare({ isSuggested: true });
      }, 2000);
    }

    if (adPromoted) {
      notification.show("Oglas je uspješno istaknut");
      setTimeout(() => {
        toggleShare({ isSuggested: true });
      }, 2000);
    }

    if (adUpdated || adNew || adPromoted) history.replace(history.location.pathname);
  }, []);

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={
        disabled
          ? null
          : () => {
            ReactGA.event({
              category: "Detalji oglasa",
              action: "Click",
              label: `Podijeli oglas (donji) - ${hrPageName}`
            });
            toggleShare();
          }
      }
      className={styles.sharingButton}
      title={"Podijeli"}
    >
      <img
        className={styles.iconSharing}
        alt={"Podijeli"}
        src={getIconUrl("sharing.svg")}
      />
      <span className={styles.text}>
        {"Podijeli"}
      </span>
    </span>
  );
}

SharingOptionsButton.defaultProps = {
  disabled: false
};

export default connect(
  state => ({
    categories: selectCategories(state)
  }),
  null
)(SharingOptionsButton);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SharingOptionsButton.tsx